'use client';

import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

import { useBulkEditLayoutMetrics } from '../bulk-edit-layout-context';

export function BulkEditFieldShell({
  width,
  align = 'left',
  dirty,
  disabled,
  children,
}: {
  width: number;
  align?: 'left' | 'right' | 'center';
  dirty?: boolean;
  disabled?: boolean;
  children: ReactNode;
}) {
  const { rowPx } = useBulkEditLayoutMetrics();
  return (
    <div
      className={cn(
        'crm-bulk-edit-cell',
        disabled && 'crm-bulk-edit-cell--disabled',
        dirty && 'crm-bulk-edit-cell--dirty',
        align === 'right' && '[&_.crm-bulk-edit-input]:text-right',
      )}
      style={{ width, height: rowPx }}
    >
      {children}
    </div>
  );
}

export function BulkEditTextInput({
  value,
  onChange,
  align = 'left',
  mono,
  type = 'text',
  step,
  min,
  placeholder,
  disabled,
  title,
}: {
  value: string | number;
  onChange: (value: string) => void;
  align?: 'left' | 'right';
  mono?: boolean;
  type?: 'text' | 'number';
  step?: string;
  min?: number;
  placeholder?: string;
  disabled?: boolean;
  title?: string;
}) {
  return (
    <input
      type={type}
      step={step}
      min={min}
      placeholder={placeholder}
      value={value}
      disabled={disabled}
      title={title}
      onChange={(e) => onChange(e.target.value)}
      className={cn(
        'crm-bulk-edit-input tabular-nums',
        align === 'right' && 'text-right',
        mono && 'font-mono text-[13px]',
      )}
    />
  );
}

export function BulkEditEmptyDash({ align = 'center' }: { align?: 'left' | 'right' | 'center' }) {
  return (
    <span
      className={cn(
        'crm-bulk-edit-empty-dash',
        align === 'right' && 'crm-bulk-edit-empty-dash--right',
        align === 'left' && 'crm-bulk-edit-empty-dash--left',
      )}
    >
      —
    </span>
  );
}

export function bulkEditSelectTriggerClass() {
  return 'crm-bulk-edit-select';
}
